'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { LoadFailure } from '@/components/records/load-failure';
import './globals.css';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { Sentry.captureException(error); }, [error]);
  return <html lang="en"><body className="min-h-dvh bg-background p-4 text-foreground sm:p-6"><LoadFailure code={error.digest} retry={reset} /></body></html>;
}
